export const NAME_REGEXP = /^[A-Z0-9 _]*[A-Z0-9][A-Z0-9 _]*$/i
